import { render, staticRenderFns } from "./Uninstall.vue?vue&type=template&id=6397e9d6"
import script from "./Uninstall.vue?vue&type=script&lang=js"
export * from "./Uninstall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6397e9d6')) {
      api.createRecord('6397e9d6', component.options)
    } else {
      api.reload('6397e9d6', component.options)
    }
    module.hot.accept("./Uninstall.vue?vue&type=template&id=6397e9d6", function () {
      api.rerender('6397e9d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/modulos/Uninstall.vue"
export default component.exports